<template>
  <BModal :model-value="modalFilter" title="Filter" centered @update:modelValue="updateModal"> 
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="">Filter</h5>
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <div class="form-group">
        <BFormSelect v-model="selectedRoomCategory" :options="roomCategories">
          <template #first>
            <BFormSelectOption :value="''" disabled>Select categories</BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
      <div class="form-group">
        <BFormSelect v-model="selectedStatus" :options="statuses">
          <template #first>
            <BFormSelectOption :value="''" disabled>Select statuses</BFormSelectOption>
          </template>
        </BFormSelect>
      </div>
    </BForm>
    <template #footer>
        <div class="d-flex justify-content-end">
            <BButton variant="light" @click="submitReservation" class="mr-2">Reset</BButton>
            <BButton variant="primary" @click="updateModal(false)">Filter</BButton>
        </div>
    </template>
  </BModal>
</template>

<script>
import { ref, inject, onMounted } from "vue";
import {
  BModal, BForm, BButton, BFormSelect, BFormSelectOption
} from "bootstrap-vue-next";

export default {
    name: 'RoomFilter',
    components: {
        BModal,
        BButton,
        BForm,
        BFormSelect,
        BFormSelectOption
    },
    props: {
        modalFilter: Boolean,
    },
    setup(props, {emit}){
        const repositories = inject('repositories');
        const roomCategoryRepository = repositories.roomCategory;

        const selectedRoomCategory = ref('')
        const roomCategories = ref([
          {
            value: '',
            text: 'All'
          }
        ])

        const getListRoomCategory = () => {
          roomCategoryRepository.getAll()
          .then((res) => {
            res.data.data.map((item) => {
              roomCategories.value.push({
                value: item.name,
                text: item.name
              })
            })
          })
          .catch(err => {
            console.error(err)
          })
        }

        const selectedStatus = ref('')
        const statuses = ref([
          {text: 'All', value: ''},
          {text: 'Available', value: 'available'},
          {text: 'Reserved', value: 'reserved'},
          {text: 'Check In', value: 'check_in'},
          {text: 'Check Out', value: 'check_out'},
          {text: 'Dirty', value: 'dirty'},
          {text: 'Under Maintenance', value: 'under_maintenance'},
          {text: 'In Cleaning', value: 'in_cleaning'},
        ])

        const updateModal = (value) => {
            emit("filter-data", selectedRoomCategory.value, selectedStatus.value)
            emit("update:modalFilter", value);
        };

        onMounted(() => {
            getListRoomCategory()
        })
        
        return{
            updateModal,
            selectedRoomCategory,
            roomCategories,
            selectedStatus,
            statuses
        }
    }
}
</script>

<style>

</style>